/**
 * PDF Tool Definitions for Agent Framework V2.
 *
 * Read-only tools for extracting text and metadata from uploaded PDFs.
 * PDFs are stored in ContentStore and accessed via contentId.
 */

export const PDF_EXTRACT_TEXT_TOOL = {
  name: 'extract_pdf_text',
  description: 'Extract text content from a PDF. Returns text organized by page.',
  input_schema: {
    type: 'object' as const,
    properties: {
      contentId: {
        type: 'string',
        description: 'PDF content ID from list_content',
      },
      pages: {
        type: 'string',
        description: 'Page range, e.g. "1-5" or "3". Max 30 pages per call. Omit for first 30 pages.',
      },
    },
    required: ['contentId'],
  },
};

export const PDF_OCR_TEXT_TOOL = {
  name: 'ocr_pdf_text',
  description: 'Extract text from scanned/image-based PDF pages using OCR (optical character recognition). Use this when extract_pdf_text returns empty or garbled text, indicating the PDF contains scanned images rather than embedded text. Slower than extract_pdf_text (~2-5 seconds per page). Requires user approval before execution.',
  input_schema: {
    type: 'object' as const,
    properties: {
      contentId: {
        type: 'string',
        description: 'PDF content ID from list_content',
      },
      pages: {
        type: 'string',
        description: 'Page range, e.g. "1-5" or "3". Max 10 pages per OCR call. Omit for first 10 pages.',
      },
    },
    required: ['contentId'],
  },
};

export const PDF_GET_METADATA_TOOL = {
  name: 'get_pdf_metadata',
  description: 'Get PDF metadata: title, author, page count, creation date, etc.',
  input_schema: {
    type: 'object' as const,
    properties: {
      contentId: {
        type: 'string',
        description: 'PDF content ID from list_content',
      },
    },
    required: ['contentId'],
  },
};
